/**
 * アカウント編集（会社管理/システム管理共有）
 *  会社管理の場合、　会社名非表示
 * 　システム管理、会社名表示
 * 
 */
/* eslint-disable */
import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
// exp components
import NBrootsDialogProcess from "components/@NBrootsDialogProcess/NBrootsDialogProcess.js";
import NBrootsMsgBox from "components/@NBrootsMsgBox/NBrootsMsgBox.js";
import Service from "utils/service/service.js"
import { BASE_URL, VALIDATE_MSG } from 'variables/config.js';
import cNullToEmpty from "utils/functions/cNullToEmpty";
// import verifyLength from "utils/validations/verifyLength";
import isNotPassNullChk from "utils/validations/isNotPassNullChk";
// import isNotPassPhoneChk from "utils/validations/isNotPassPhoneChk";
import isNotPassCharTypeChk from "utils/validations/isNotPassCharTypeChk";
import isNotPassLengthChk from "utils/validations/isNotPassLengthChk";
import isNotPassEmailChk from 'utils/validations/isNotPassEmailChk';

import styles from "assets/jss/material-dashboard-pro-react/views/CommonPopup/CommonPopupStyle";
import { corpsInfo } from 'variables/runtimeInfos.js';

export default function UserListDetailPopup(props) {

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  //進捗画面
  const [isLoading, setIsLoading] = React.useState(false);
  //Msg画面用情報             msgInfo     : [表示FLG, Msg, Type:"info","success","warning","danger","primary","rose"]    
  const [msgInfo, setMsgInfo] = React.useState([false, '', 'info']);
  //画面編集項目＜初期状態＞
  // メールアドレス  ユーザ名 	フリカナ 	パスワード 
  var t = {
    companyID: "",
    companyName: "",
    //入力項目
    id: "",
    email: "",
    name: "",
    kana: "",
    password: "",
    admin: 0,

    updateIndex: "",       //更新の場合、必ず必須
    //MSG項目
    msg_email: "",       //MSG項目
    msg_name: "",
    msg_kana: "",
    msg_password: "",
    //CHECK結果
    chk_email: "",
    chk_name: "",
    chk_kana: "",
    chk_password: "",

  };
  // const [ vals, setVals ] = React.useState(t);
  const [vals, setVals] = React.useState([t]);   

  const { info, setInfo } = props;

  const open = info[0];
  const flgCropAdmin = info[1].flag === "MngCrop" ? true : false;

  //初期化処理
  React.useEffect(() => {
    if (open) {
      //進捗画面
      setIsLoading(true);
      //情報のロード
      formatDetailData();
    }

    //Clean
    return () => {
      setVals([t]);
    }
  }, [open]);    //毎回OPENする時処理を行う


  const formatDetailData = () => {
    var url = BASE_URL + "/API/MntSysUserList/Get";
    //　検索条件  前画面から取得
    var data = {
      id    : info[1].id     
    };
    // console.log(data);
    var tVals;
    Service(props, url, data).then(resp => {
      // console.log(resp)
      // 正常系
      if (resp.status === 0) {
        var info = resp.infos;
        //画面編集項目（SET）
        tVals = {
          id: info.id,

          companyID: cNullToEmpty(info.companyID),
          companyName: cNullToEmpty(info.companyName),

          email: cNullToEmpty(info.email),
          name: cNullToEmpty(info.name),
          kana: cNullToEmpty(info.kana),
          password: cNullToEmpty(info.password),
          admin: cNullToEmpty(info.admin),
          updateIndex: info.updateIndex,       //更新の場合、必ず必須
        };
        // //Copy　STATE情報　By　Value
        // var tResult = JSON.parse(JSON.stringify(tVals));

        setVals([tVals]);


      } else {
        //その他APIエラー   
        tVals = {
          //入力項目
          id: "",
          email: "",
          name: "",
          companyName: "",
          kana: "",
          password: "",
          admin: 0,
        };

        setVals([tVals]);


        setMsgInfo([true, resp.msg, 'warning']);
      }
      setIsLoading(false);
    }).catch(resp => {
      //接続エラーなど
      setIsLoading(false);
      setMsgInfo([true, 'エラー', 'danger']);
    });
  };


  //編集発生する時
  const handleEditOnChange = (name, value) => {
    let tVals = vals[0];
    //STATE内容、項目名、入力値
    validate(tVals, name, value);
    //情報をSTATEに保存する。
    if (name === "admin") {
      tVals["admin"] == 1 ? tVals["admin"] = 0 : tVals["admin"] = 1;
    } else {
      //情報をSTATEに保存する。
      tVals[name] = value;
    }
    // tVals[name]  = value;
    // var tResult = Object.assign({}, tVals);
    // setVals(tResult);
    setVals([tVals]);

  }

  //企業変更の場合
  const handleChangeCropList = (e) => {
    let tVals = vals[0];
    //選択情報をSTATEに保存
    if (e.target.name === 'corpSelect') {
      //情報をSTATEに保存する。
      // tVals.companyID = e.target.value;
      tVals['companyID'] = e.target.value;
      setVals([tVals]);
      // var tResult = Object.assign({}, tVals);
      // setVals(tResult);

    }
  }

  function validate(tVals, name, value) {
    //チェック処理
    if (name === 'email') {
      isNotPassNullChk(value) ?
        (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_001) :
      isNotPassEmailChk(value) ?
          (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_101) :
      isNotPassLengthChk(value, null, 100) ?
            (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_200.replace("?", 100)) :
            (tVals["chk_" + name] = "success", tVals["msg_" + name] = "");

    } else if (name === 'name') {
      isNotPassNullChk(value) ?
        (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_001) :
        isNotPassCharTypeChk(value, "zenkaku") ?
          (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_003) :
          isNotPassLengthChk(value, null, 100) ?
            (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_200.replace("?", 100)) :
            (tVals["chk_" + name] = "success", tVals["msg_" + name] = "");

    } else if (name === 'kana') {
      isNotPassNullChk(value) ?
        (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_001) :
        isNotPassCharTypeChk(value, 'katakana') ?
          (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_005) :
          isNotPassLengthChk(value, null, 50) ?
            (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_200.replace("?", 50)) :
            (tVals["chk_" + name] = "success", tVals["msg_" + name] = "");

    } else if (name === 'password') {
      isNotPassNullChk(value) ?
        (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_001) :
        isNotPassCharTypeChk(value, "alphanumeric") ?
          (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_006) :
          isNotPassLengthChk(value, 6, null) ?
            (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_201.replace("?", 6)) :
            isNotPassLengthChk(value, null, 15) ?
            (tVals["chk_" + name] = "error", tVals["msg_" + name] = VALIDATE_MSG.MSG_200.replace("?", 15)) :
            (tVals["chk_" + name] = "success", tVals["msg_" + name] = "");
    }
  }


  //保存ボタン押す
  const handleClickOKBtn = () => {

    let tVals = vals[0];
    //一括チェック
    validate(tVals, 'email', tVals.email);
    validate(tVals, 'name', tVals.name);
    validate(tVals, 'kana', tVals.kana);
    validate(tVals, 'password', tVals.password);

    //エラーがある場合、ＭＳＧを出す、処理を中断する。
    if (tVals["chk_email"] === "error" ||
      tVals["chk_name"] === "error" ||
      tVals["chk_kana"] === "error" ||
      tVals["chk_password"] === "error") {

      // setVals(tVals);
      setVals([tVals]);
      return;
    }

    //送信処理
    var tUserListDetailInfo = [
      //当画面表示FLG    
      false,
      //当画面編集情報    
      vals[0],
      true
    ]
    //前画面に渡す、画面閉じる
    setInfo(tUserListDetailInfo);
  }

  //キャンセルボタン押す
  const handleClickCancelBtn = () => {
    var tUserListDetailInfo = [
      //当画面表示FLG    
      false,
      //当画面編集情報       
      {},
      //IsAfterOK
      false
    ]
    setInfo(tUserListDetailInfo);
  }

  return (
    <Dialog onClose={handleClickCancelBtn} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle id="customized-dialog-title" className={classes.dialogHeader} onClose={handleClickCancelBtn}>
      アカウント編集
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="warning"
          onClick={handleClickCancelBtn}
          style={{ float: "right" }}
        >
          <Close className={classes.modalClose} />
        </Button>
      </DialogTitle>
      <DialogContent>
        <GridItem xs={12} sm={12}>
          {flgCropAdmin ?
            ''
            :
            <FormControl style={{ width: "100%" }} className={classes.selectFormControl}>
              <InputLabel htmlFor="corpSelect" className={classes.selectLabel}>企業</InputLabel>
              <Select
                MenuProps={{ className: classes.selectMenu }}
                classes={{ select: classes.select }}
                value={vals[0].companyID}
                onChange={handleChangeCropList}
                inputProps={{ name: "corpSelect", id: "corpSelect" }}>
                <MenuItem disabled classes={{ root: classes.selectMenuItem }}> 企業を選択</MenuItem>
                {corpsInfo ? corpsInfo.lst.map((item, key) =>
                  <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id} key={key}>
                    {item.corpname}
                  </MenuItem>
                ) : null}
              </Select>
            </FormControl>
          }

          <CustomInput
            labelText="メールアドレス *"
            id="email"
            success={vals[0].chk_email === "success"}             // chkResult + Json.prop
            error={vals[0].chk_email === "error"}
            formControlProps={{ fullWidth: true }}
            inputProps={{
              value: vals[0].email,
              onChange: event => {
                handleEditOnChange("email", event.target.value);
              }
            }}
            helperText={vals[0].msg_email}
          />
          <CustomInput
            labelText="ユーザー名 *"
            id="name"
            success={vals[0].chk_name === "success"}             // chkResult + Json.prop
            error={vals[0].chk_name === "error"}
            formControlProps={{ fullWidth: true }}
            inputProps={{
              value: vals[0].name,
              onChange: event => {
                handleEditOnChange("name", event.target.value);
              }
            }}
            helperText={vals[0].msg_name}
          />
          <CustomInput
            labelText="フリガナ *"
            id="kana"
            success={vals[0].chk_kana === "success"}             // chkResult + Json.prop
            error={vals[0].chk_kana === "error"}
            formControlProps={{ fullWidth: true }}
            inputProps={{
              value: vals[0].kana,
              onChange: event => {
                handleEditOnChange("kana", event.target.value);
              }
            }}
            helperText={vals[0].msg_kana}
          />
          <CustomInput
            labelText="パスワード *"
            id="password"
            success={vals[0].chk_password === "success"}             // chkResult + Json.prop
            error={vals[0].chk_password === "error"}
            formControlProps={{ fullWidth: true }}
            inputProps={{
              value: vals[0].password,
              onChange: event => handleEditOnChange("password", event.target.value)
            }}
            helperText={vals[0].msg_password}
          />
          <Box className={classes.checkboxAndRadio}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={vals[0].admin === 1}
                  onChange={event => handleEditOnChange("admin", event.target.value)}
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              classes={{
                label: classes.label,
                root: classes.labelRoot
              }}
              label="管理者"
            />
          </Box>
        </GridItem>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClickCancelBtn} color="warning">
          キャンセル
          </Button>
        <Button onClick={handleClickOKBtn} color="warning">
          保存
          </Button>
      </DialogActions>
      {/* 共通ダイアログ画面 */}
      <NBrootsDialogProcess open={isLoading} color="warning" />
      <NBrootsMsgBox open={msgInfo[0]} message={msgInfo[1]} color={msgInfo[2]} close setMessage={setMsgInfo} />
    </Dialog>

  );
}
